module.exports = __webpack_public_path__ + "img/DSC2074.21848846.jpg";